import { combineReducers } from 'redux';

import dashboard from './dashboard/reducer';

export default combineReducers({
  dashboard,
});



// WEBPACK FOOTER //
// ./src/pages/home/state/reducer.js